/*
  Marks the shop's headings for the landing's character reveal.

  The landing gets `data-split="chars"` from its heading block; the theme's
  headings are plain <h1>/<h2> written into two dozen sections, so they are
  tagged here instead. landing-split.js does the actual work and is loaded
  right after this file, so tagging always happens first.

  Left alone: the header and footer (outside #MainContent), screen-reader
  headings, product-card titles (they already ride the theme's own section
  reveal, and a grid of scrubbing titles reads as noise), and accordion
  summaries, whose markup the theme's own scripts reach into.
*/
(function () {
  const HEADINGS = [
    '#MainContent h1',
    '#MainContent h2',
    '#MainContent h3',
    '#MainContent .title',
  ].join(',');

  const SKIP = [
    '.visually-hidden',
    '.card__heading',
    '.accordion__title',
    'summary *',
    '[data-split]',
  ].join(',');

  /* Publisher marks up plenty of utility labels as headings — "Filter:",
     "Sort by:", "1 product", the mobile facet drawer's title. They are h2s
     set in body type, so the reveal is limited to headings actually sized
     as headings; anything under 24px is a label, not a headline. */
  const MIN_SIZE = 24;

  function tag(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(HEADINGS).forEach((el) => {
      if (el.matches(SKIP) || el.closest('summary, .card__heading, .facets, .mobile-facets')) return;
      if (!el.textContent.trim()) return;
      if (parseFloat(getComputedStyle(el).fontSize) < MIN_SIZE) return;
      el.setAttribute('data-split', 'chars');
    });
  }

  tag();

  /* Registered before landing-split.js binds its own handler, so a section
     re-rendered in the theme editor is tagged before it is split. */
  document.addEventListener('shopify:section:load', (e) => tag(e.target));
})();
